import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';

import { Pill } from 'ui-components/components/pill';
import { Tooltip } from 'ui-components/components/tooltip';

import { messages } from './messages';
import style from './tags-summary.module.css';

/**
 * @typedef {import('../../../../prop-types/tag').TagPropType} Tag
 */

const MAX_FULL_TAGS = 2;
const MAX_COLLAPSED_TAGS = 7;

/**
 * @param {object} props
 * @param {Tag[]} props.selectedTags
 * @param {string} props.pillWrapperClassName
 * @param {string} props.pillClassName
 * @param {string} props.pillTextClassName
 * @returns {JSX.Element|undefined}
 */
export const TagsSummary = ({ selectedTags, pillWrapperClassName, pillClassName, pillTextClassName }) => {
  if (!selectedTags?.length) {
    return;
  }

  if (selectedTags.length <= MAX_COLLAPSED_TAGS) {
    return (
      <div className={classnames(style['pill-container'], pillWrapperClassName)}>
        {selectedTags.map((tag, index) => (
          <Pill
            key={index}
            className={pillClassName}
            collapsed={selectedTags.length > MAX_FULL_TAGS}
            color={tag.hexColor}
            label={tag.name}
            textClassName={pillTextClassName}
            theme='tag'
          />
        ))}
      </div>
    );
  }

  const toolTipText = selectedTags.map((tag, index) => <div key={index}>{tag.name}</div>);

  return (
    <Tooltip position='bottom' text={toolTipText}>
      <span>
        <FormattedMessage {...messages.tagsSummaryText} values={{ tagCount: selectedTags.length }} />
      </span>
    </Tooltip>
  );
};
